import { Dialog } from "@hubertai/hubert-component-library";
import { X } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import TransitionPage from "../../../pages/transition/TransitionPage";
import { Button, HorizontalLine, Text } from "../../elements";

const IframeModal = ({ interviewId }: { interviewId: string }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);

    const src = `${import.meta.env.VITE_INTERVIEW_URL}/preview/${interviewId}`;

    return (
        <Dialog.Root>
            <Dialog.Trigger>
                <Button size="small">{t("Interview.ScriptFromInterview.ButtonText_SeeWholeTranscript")}</Button>
            </Dialog.Trigger>

            <Dialog.Content className="modal-wrapper large iframe-modal-popup max-w-[calc(100vw-60px)]!">
                <Dialog.Close>
                    <X className="close-icon" />
                </Dialog.Close>

                <div>
                    <Text size="large" weight="semibold">
                        {t("Interview.ScriptFromInterview.Title")}
                    </Text>
                    <HorizontalLine weight="semi-dark" />
                </div>
                {loading && (
                    <TransitionPage
                        title={t("Interview.ScriptFromInterview.Loading_Title")}
                        subtitle={t("Interview.ScriptFromInterview.Loading_Subtitle")}
                    />
                )}
                <iframe src={src} tabIndex={1} title="Interview script" onLoad={() => setLoading(false)} />
            </Dialog.Content>
        </Dialog.Root>
    );
};

export default IframeModal;
